export const EmployeeCategory = {
  FULL_TIME: "fulltime",
  PART_TIME: "parttime",
  INTERN: "intern"
} as const;

// types
export type TEmployeeCategory = (typeof EmployeeCategory)[keyof typeof EmployeeCategory];
